/* eslint-disable react/jsx-props-no-spreading,react/prop-types */
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { AutoCompleteTextField } from '../Autocomplete/Autocomplete.styled';
import { StudentFilterFragmentFragment } from '../../generated/graphql';
import useStudentsFilter from './students-filter-hook';
import { SxProps, Theme } from '@mui/system';

interface Props {
  error?: boolean;
  sx?: SxProps<Theme> | undefined;
  className?: string;
  value?: StudentFilterFragmentFragment | null | string;
  onChange?: (data: StudentFilterFragmentFragment | null | string) => void;
  placeholder?: string;
  idSelectOnly?: boolean;
}

type StudentValue = StudentFilterFragmentFragment | null | undefined;

const StudentFilter = ({
  className,
  placeholder,
  onChange,
  value,
  sx,
  idSelectOnly = false,
}: Props) => {
  const {
    students,
    loading,
  } = useStudentsFilter();
  const onSelectChange = (_: any, student: StudentFilterFragmentFragment | null) => {
    onChange?.(idSelectOnly ? (student?.id ?? '') : student);
  };

  const selectedValue: StudentValue = idSelectOnly ? students?.find((item) => item.id === value) ?? null : value as StudentValue;
  return (
    <Autocomplete
      className={className}
      options={students || []}
      getOptionLabel={(option: any) => `${option?.user?.first_name ?? ''} ${option?.user?.last_name ?? ''}`}
      isOptionEqualToValue={(option: any, selected: any) => option?.id === selected?.id}
      onChange={onSelectChange}
      value={selectedValue}
      disabled={loading}
      sx={sx}
      renderInput={(params) => (
        <AutoCompleteTextField
          {...params}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
        />
      )}
    />
  );
};

export default React.memo(StudentFilter);
